import { render } from "./PrcHandleTab.vue?vue&type=template&id=27ee73a7&scoped=true"
import script from "./PrcHandleTab.vue?vue&type=script&lang=js"
export * from "./PrcHandleTab.vue?vue&type=script&lang=js"

import "./PrcHandleTab.vue?vue&type=style&index=0&id=27ee73a7&scoped=true&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ee73a7"]])

export default __exports__